import type {PropsWithChildren} from 'react'

import {AllowedValuesEditor} from './AllowedValuesEditor'
import {DefinitionDescriptionField} from './DefinitionDescriptionField'
import {DefinitionFormActions} from './DefinitionFormActions'
import {DefinitionNameField} from './DefinitionNameField'
import {DefinitionRegexEditor} from './DefinitionRegexEditor'
import {DefinitionTypeSelector} from './DefinitionTypeSelector'
import styles from './PropertyDefinitionForm.module.css'
import {PropertyValueField} from './PropertyValueField'
import {RequiredDefinitionEditor} from './RequiredDefinitionEditor'

export function PropertyDefinitionForm({children}: PropsWithChildren) {
  return <div data-testid="property-definition-form">{children}</div>
}

PropertyDefinitionForm.AllowedValuesEditor = AllowedValuesEditor
PropertyDefinitionForm.DescriptionField = DefinitionDescriptionField
PropertyDefinitionForm.RegexEditor = DefinitionRegexEditor
PropertyDefinitionForm.Actions = DefinitionFormActions
PropertyDefinitionForm.NameField = DefinitionNameField
PropertyDefinitionForm.TypeSelector = DefinitionTypeSelector
PropertyDefinitionForm.RequiredDefinitionEditor = RequiredDefinitionEditor
PropertyDefinitionForm.PropertyValueField = PropertyValueField
PropertyDefinitionForm.AdditionalSettingsSection = AdditionalSettingsSection

function AdditionalSettingsSection({children}: PropsWithChildren) {
  return <div className={styles.additionalSettingsSection}>{children}</div>
}
